import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secretText',
  standalone: false,
})
export class SecretTextPipe implements PipeTransform {
  transform(text: string): string {
    return text
      .substring(0, text.length - 4)
      .split('')
      .map(() => '*')
      .join('')
      .concat(text.substring(text.length - 4, text.length));
  }
}
